import React from "react";
// @ts-expect-error - this will be resolved at build time
import { Box, Text } from "@xsolla/xui-primitives";

interface PeriodToggleProps {
  value: "am" | "pm";
  onChange: (value: "am" | "pm") => void;
  disabled?: boolean;
  fontSize: number;
  textColor: string;
  testID?: string;
}

export const PeriodToggle: React.FC<PeriodToggleProps> = ({
  value,
  onChange,
  disabled = false,
  fontSize,
  textColor,
  testID,
}) => {
  const toggle = () => {
    if (!disabled) {
      onChange(value === "am" ? "pm" : "am");
    }
  };

  return (
    <Box
      onPress={toggle}
      cursor={disabled ? "default" : "pointer"}
      justifyContent="center"
      alignItems="center"
      paddingHorizontal={4}
      role="button"
      aria-label={`Time period: ${value.toUpperCase()}. Click to toggle.`}
      data-testid={testID}
    >
      <Text color={textColor} fontSize={fontSize} fontWeight="500">
        {value}
      </Text>
    </Box>
  );
};
